import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import DriverSwiping from './MessageDetails/DriverSwiping.vue';
import { domainName } from "../../../utility/index"

export default {
    name: "DriverStatus",
    components: { tree, iTable, IPagination, DriverSwiping },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                driverNum: '',
                driverName: '',
                state: ''
            },
            StateList: [
                { id: '', name: this.$t('common.all') },
                { id: '1', name: this.$t('BatteryStatus.work') },
                { id: '0', name: this.$t('BatteryStatus.leisure') },
            ],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "driverNum",
                    label: this.$t('common.driverNum'),
                    align: "center",
                    width: '180'
                },
                {
                    prop: "driverName",
                    label: this.$t('common.driverName'),
                    align: "center",
                    width: '130'
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",
                    width: '120'
                },
                {
                    prop: 'state',
                    label: this.$t('BatteryStatus.batteryState'),
                    align: 'center',
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.state == null ? '' : params.row.state == 0 ? 'info' : 'success' }
                        }, params.row.state == null ? '' : params.row.state == 0 ? this.$t('BatteryStatus.leisure') : this.$t('BatteryStatus.work'))
                    }
                },
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                    width: '130'
                },
                {
                    prop: "messageTime",
                    label: this.$t('common.messageTime'),
                    align: "center",
                    width: '200',
                    // render: (h, params) => {
                    //     return h('span', this.$formatTime(params.row.messageTime))
                    // }
                },
                {
                    prop: "remarks",
                    label: this.$t('common.remark'),
                    align: "center",
                    width: '240'
                },
            ],
            dialogFormVisible: false,
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        isBtn: "DRIVERSTATUS_DETAIL",
                        method: (index, row) => {
                            this.dialogFormVisible = true
                            this.queryDetails(index, row)
                        }
                    }
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            terminalId: '',
            carId: '',
            driverNum: ''
        }
    },
    created() {
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        queryDetails(index, row) {
            console.log(row)
            this.driverNum = row.driverNum
            this.$nextTick(() => {
                this.$refs.driverSwiping.getDriverSwipingCard()
            })
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            if (this.$route.params.driverNum) {
                this.formInline.driverNum = this.$route.params.driverNum
                this.formInline.driverName = this.$route.params.name
            }
            this.getRealTimeStatus()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getRealTimeStatus()
        },
        getRealTimeStatus() {
            let param = {
                orgId: this.id,
                driverNum: this.formInline.driverNum,
                driverName: this.formInline.driverName,
                state: this.formInline.state,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('DriverStatus/GET_SELECTDRIVERSTATE', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getRealTimeStatus()
        },
        onClear() {
            this.formInline = {
                driverNum: '',
                driverName: '',
                state: ''
            }
            this.getRealTimeStatus()
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportSelectDriverState?orgId=${this.id}&driverNum=${this.formInline.driverNum}&driverName=${this.formInline.driverName}&state=${this.formInline.state}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportSelectDriverState?orgId=${this.id}&driverNum=${this.formInline.driverNum}&driverName=${this.formInline.driverName}&state=${this.formInline.state}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getRealTimeStatus();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}